!function($) {
  $(document).ready((function() {
      $(".pricing_page").on("click", ".dropbtn", (function() {
          $("#partnersDropdown").slideToggle().toggleClass("show"),
          $("span.dropdown_default").toggleClass("dropdown_arrow")
      }
      ));
      $(".brokerage-rates-container .brokerage-rates-tab-header").on("click", ".tab", (function() {
          var val = $(this).find("span").attr("val");
          $(".brokerage-rates-container .tab-content").find('.tab-pane:not("' + val + '")').removeClass("active"),
          $(".brokerage-rates-container .brokerage-rates-tab-header").find("span:not([val=" + val + "])").parents(".tab").removeClass("active"),
          $(this).addClass("active"),
          $(".brokerage-rates-container .tab-content").find(".tab-pane#" + val).addClass("active")
      }
      )),
      $(".pricing_help_section").on("click", ".panel-trigger", (function() {
          var val = $(this).attr("val");
          $(".pricing_help_section").find(".panel-collapse:not(" + val + ")").slideUp("fast");
          var inactiveTab = $(".pricing_help_section").find(".panel-trigger:not([val=" + val + "])");
          $(this).toggleClass("collapsed"),
          $(val).slideToggle("fast"),
          inactiveTab.hasClass("collapsed") && inactiveTab.removeClass("collapsed")
      }
      )),
      $(".view-more-button").on("click", (function() {
          $("#more-faqs").removeClass("d-none"),
          $(".view-more-button").addClass("d-none"),
          $(".view-less-button").removeClass("d-none")
      }
      )),
      $(".view-less-button").on("click", (function() {
          $("#more-faqs").addClass("d-none"),
          $(".view-less-button").addClass("d-none"),
          $(".view-more-button").removeClass("d-none")
      }
      )),
      $("body").on("click", (function(event) {
          if (!event.target.matches(".dropbtn")) {
              var i, dropdowns = document.getElementsByClassName("dropdown-content");
              for (i = 0; i < dropdowns.length; i++) {
                  var openDropdown = dropdowns[i];
                  openDropdown.classList.contains("show") && openDropdown.classList.remove("show")
              }
          }
      }
      ))
  }
  ))
}(jQuery);
let param = ""
, param_index = window.location.href.indexOf("?");
-1 != param_index && (param = "&".concat(window.location.href.slice(window.location.href.indexOf("?") + 1)));
let pathname = "";
function pushToDataLayer(message, hiddenValue) {
  "event" == hiddenValue ? "undefined" != typeof window && window?.dataLayer && window.dataLayer.push({
      event: "open_demat_account_popup_click"
  }) : "undefined" != typeof window && window?.dataLayer && window.dataLayer.push({
      event: "sign_up_click",
      cta_text: "Sign up",
      status: hiddenValue,
      message_text: message
  })
}
function validateMobile(mobileNumber, data) {
  const hiddenInput = data.querySelector('input[type="hidden"]')
    , hiddenValue = hiddenInput ? hiddenInput.value : "failed";
  return "" == mobileNumber ? (data.getElementsByClassName("error-message")[0].innerHTML = "<span>Enter your mobile number to sign up</span>",
  "failed" == hiddenValue && pushToDataLayer("Enter your mobile number to sign up", hiddenValue),
  !1) : /^(6|7|8|9)\d{9}$/.test(mobileNumber) && !mobileNumber.startsWith("0") || (data.getElementsByClassName("error-message")[0].innerHTML = "<span>Please enter valid mobile no.</span>",
  "failed" == hiddenValue && pushToDataLayer("Please enter valid mobile no.", hiddenValue),
  !1)
}
function isNumber(evt) {
  const charCode = (evt = evt || window.event).which ? evt.which : evt.keyCode;
  return !(charCode > 31 && (charCode < 48 || charCode > 57))
}
function setCookie(cname, cvalue, secs) {
  document.cookie = cname + "=" + cvalue + ";max-age=" + secs + ";path=/;domain=.upstox.bond;SameSite=strict;Secure"
}
function proceedWithLazyLogin(event, data) {
  event.preventDefault();
  const phone = data.elements[0].value
    , id = data.elements[0].id;
  if (param_new = "dark" == id ? "_dark" : "light" == id ? "_light" : param,
  validateMobile(phone, data)) {
      data.getElementsByClassName("error-message")[0].innerHTML = "",
      setCookie("lead_phone_number", phone, 300);
      const hiddenInput = data.querySelector('input[type="hidden"]');
      pushToDataLayer("success", hiddenInput ? hiddenInput.value : "success"),
      location.href = "https://wa.me/+917092362098" 
  }
}
pathname = "/" == location.pathname ? "home_cta" : location.pathname.replace(/^\/|\/$/g, "");
//# sourceMappingURL=pricing.js.map
